import { StylesConfig} from 'react-select';





 export const customStyles = {
   dropdownIndicator: (base, state) => ({
     ...base,
     color: 'var(--primary)',
     opacity: state.isDisabled ? 0.5 : 1,
     transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null,
     cursor: 'pointer',
     '&:hover': {
       color: 'var(--primary)'
     }
   }),

   control: (baseStyles, state) => ({
     ...baseStyles,
     color: "var(--black)",
     boxShadow: 'none',
     backgroundColor: "var(--white)",
     width: "auto",
     fontWeight: "400",
     fontSize: "16px",
     borderRadius: "3px",
     lineHeight: "22px",
     position: "relative",
     border: 'border: 1px solid black',

     "&:hover": {
       color: "var(--black)",
       border: '1px solid black !important'
     },
     "&:active": {
       border: '1px solid black !important'
     },
     "&:": {
       border: '1px solid black !important'
     },

     "&:focus": {
       border: "1px solid black !important"
     },
     "&:focus-visible": {
      border: "1px solid black !important"
    },
    "&:focus-within": {
      border: "1px solid black !important"
    }
   }),
   menu: () => ({
     width: '100%',
     position: 'absolute',
     border: '1px solid black',
     borderRadius: '3px',
     zIndex: 1
   }),
   menuList: (provided) => ({
    ...provided,
    maxHeight: "150px"
  }),

   input: (provided, state) => ({
     ...provided,
    
   }),

   container: (provided, state) => ({
     ...provided,
     border: "none",
  
   }),
   valueContainer: (provided, state) => ({
     ...provided,
     cursor: "pointer",
     
    
   }),
  
   
   

   option: (provided, state) => {
     const optionStyle = {
       ...provided,
       lineHeight: '22px',
       display: 'flex',
       alignItems: 'center',
       textAlign: 'left',
       backgroundColor: state.isSelected ? "var(--primary)" : "white",
       cursor: "pointer",
       borderRadius: '3px',

       "&:hover": {
         backgroundColor: "var(--primary)",
         color: state.isSelected ? "black" : "white"
       },

       ":active": {
         backgroundColor: "var(--primary)",
         color: 'black'
       }
     }
     return optionStyle
   },
   noOptionsMessage: (provided, state) => {
    const noOptionStyle = {
    ...provided,
    backgroundColor: "#FFFFFF",
   } 
   return noOptionStyle 
  },
   singleValue: (provided, state) => {
     const color = state.isDisabled && "black";
     const transition = 'opacity 300ms';
     return { ...provided, color, transition};
   }
} as StylesConfig;